import { AsyncState, loadingAsyncState } from "widgets-for-react";
import { BlogsResponse, getBlogCategories, getBlogs } from "./blogOverviewApi";
import { Category } from "../../../../Shared/api/drupal/drupalTypes";
import { BasePageProps } from "../../components/page_renderer";

export interface BlogOverviewProps extends BasePageProps {
  kind: "blogOverview"
  pageTitle: string
  headerTitle: string
  description: string
  imageUrl: string
  imageUrlLarge: string
  phImageUrlSmall?: string
  phImageUrl: string
  phImageUrlLarge: string
  imageAlt: string
  pageSize: number
  key?: string
}

export interface BlogOverviewState {
  blogpostLoader: AsyncState<BlogsResponse>
  blogCategoriesLoader: AsyncState<Category[]>
  currentPage: number
  selectedCategory: string
}

export const initialBlogResponse: BlogsResponse = { totalResults: 0, posts: [] }

export const initialState: (props: BlogOverviewProps) => BlogOverviewState = (props) => ({
  blogpostLoader: loadingAsyncState(getBlogs(1, props.pageSize, null), initialBlogResponse),
  blogCategoriesLoader: loadingAsyncState(getBlogCategories(), []),
  currentPage: 1,
  selectedCategory: null
})

export type BlogOverviewLayoutProps = BlogOverviewProps & BlogOverviewState & {
  setPage: (page: number) => void
  setCategory: (category: Category) => void
}

export const resultsClass = "blog-results"